<div [ngClass]="{ container: true, 'fondo-negro': isLanding }">
  <div class="content-wrapper">
    <app-header [isLanding]="isLanding"></app-header>
    <router-outlet></router-outlet>
    <app-spinner></app-spinner>
  </div>
  <app-first-information-layer *ngIf="!showManualForm"></app-first-information-layer>
  <footnote></footnote>
</div>
